import React, { Component } from "react";
import { languages } from "../../constants/languages";
// import DragIcon from "@material-ui/icons/DragHandle";
import Typography from "@material-ui/core/Typography";
import EditBreakContainer from "../../containers/schedule/EditBreakContainer";
import { Tooltip } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/Error";
import { withStyles } from "@material-ui/core/styles";
import { withTheme } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import { alpha } from "@material-ui/core/styles/colorManipulator";

const LightTooltip = withStyles((theme) => ({
  arrow: {
    color: theme.palette.common.white,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    boxShadow: theme.shadows[4],
    fontSize: 11,
  },
}))(Tooltip);

class Break extends Component {
  state = {
    mouseOver: false,
  };

  onMouseEnter = (e) => {
    this.setState({ mouseOver: true });
  };

  onMouseLeave = (e) => {
    this.setState({ mouseOver: false });
  };

  highlightTeam = (teamId) => {
    let teamElements = document.getElementsByClassName(
      "teamElementId" + teamId
    );
    // let teamElements = document.getElementsByClassName("teamElement");
    for (var i = 0; i < teamElements.length; i++) {
      let element = teamElements[i];
      element.style.textShadow = "1px 0px 0px";
    }
    // let name = this.props.referee.name || "";
    // if (this.props.tournament.teamsAsRefs) {
    //   for (var x = 0; x < teamElements.length; x++) {
    //     let element = teamElements[x];
    //     if (element.textContent === name) {
    //       element.style.fontWeight = "bold";
    //     }
    //   }
    // }
  };

  unHighlightTeam = (teamId) => {
    let teamElements = document.getElementsByClassName(
      "teamElementId" + teamId
    );
    // let teamElements = document.getElementsByClassName("teamElement");
    for (var i = 0; i < teamElements.length; i++) {
      let element = teamElements[i];
      element.style.textShadow = "";
    }

    // let name = this.props.referee.name || "";
    // if (this.props.tournament.teamsAsRefs) {
    //   for (var x = 0; x < teamElements.length; x++) {
    //     let element = teamElements[x];
    //     if (element.textContent === name) {
    //       element.style.fontWeight = "";
    //     }
    //   }
    // }
  };

  checkOverlap = (matchStartTime, matchEndTime, t, add24) => {
    let start = t[0];
    let end = t[1];
    if (end < start) {
      // add 24 hours
      let timeSplitted = end.split(":");
      let hours = Number(timeSplitted[0] + 24).toString();
      if (matchStartTime < end) {
        // add 24 hours
        let timeSplittedEnd = matchEndTime.split(":");
        let hoursEnd = Number(timeSplittedEnd[0] + 24).toString();
        matchEndTime = hoursEnd + ":" + timeSplittedEnd[1];

        let timeSplittedStart = matchStartTime.split(":");
        let hoursStart = Number(timeSplittedStart[0] + 24).toString();
        matchStartTime = hoursStart + ":" + timeSplittedStart[1];
      }
      end = hours + ":" + timeSplitted[1];
    } else if (add24 && start < this.props.endTime) {
      // add 24 hours
      let timeSplitted = end.split(":");
      let hours = Number(timeSplitted[0] + 24).toString();
      end = hours + ":" + timeSplitted[1];

      let timeSplittedStart = start.split(":");
      let hoursStart = Number(timeSplittedStart[0] + 24).toString();
      start = hoursStart + ":" + timeSplittedStart[1];
    }
    return (
      (start < matchEndTime && start >= matchStartTime) ||
      (end > matchStartTime && end <= matchEndTime) ||
      (start <= matchStartTime && end >= matchEndTime)
    );
  };

  render() {
    // check for conflicts
    let overlapCounts = {};
    let eventHasOverlap = false;
    let eventTeams = (this.props.break.teams || []).filter(
      (t) => this.props.teamsByKey[t] !== undefined
    );
    if (
      this.props.dividedPerPoule &&
      this.props.dividedPerPoule.teams &&
      this.props.break.field !== undefined &&
      this.props.break.field !== null &&
      this.props.isEvent
    ) {
      // let dateStringStart = moment().format("YYYY/MM/DD");
      // let dateStringEnd =
      //   this.props.endTime < this.props.startTime
      //     ? moment()
      //         .add(1, "days")
      //         .format("YYYY/MM/DD")
      //     : moment().format("YYYY/MM/DD");
      // let eventRange = moment.range(
      //   moment(
      //     dateStringStart + " " + this.props.startTime,
      //     "YYYY/MM/DD HH:mm"
      //   ),
      //   moment(dateStringEnd + " " + this.props.endTime, "YYYY/MM/DD HH:mm")
      // );
      let matchStartTime = this.props.startTime;
      let matchEndTime = this.props.endTime;
      let add24 = false;
      if (matchEndTime < matchStartTime) {
        // add 24 hours
        let timeSplitted = matchEndTime.split(":");
        let hours = Number(timeSplitted[0] + 24).toString();
        matchEndTime = hours + ":" + timeSplitted[1];
        add24 = true;
      }
      eventTeams.forEach((t) => {
        let teamTimes = (
          ((this.props.dividedPerPoule || {})["teams"] || {})[t] || []
        ).concat(((this.props.dividedPerPoule || {})["events"] || {})[t] || []);

        let overlapTeam = teamTimes.filter((t) => {
          return this.checkOverlap(matchStartTime, matchEndTime, t, add24);
        });
        let count = overlapTeam.length;
        overlapCounts[t] = count;
        if (count > 1) {
          eventHasOverlap = true;
        }
      });
    }
    return (
      <div
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        id={this.props.break.id + "id"}
      >
        <table
          style={{
            width: "100%",
            padding: 5,
            border: "1px solid #efefef",
            height: 68,
            backgroundColor: this.props.isEvent
              ? alpha(this.props.theme.palette.primary.main, 0.04)
              : "rgba(166, 162, 162, 0.1)",
          }}
          className="hoverItem"
        >
          <tbody>
            <tr>
              {this.props.break.field !== undefined &&
                this.props.break.field !== null && (
                  <td valign="top" style={{ paddingRight: 10, width: 47 }}>
                    <Typography variant="body2">
                      {this.props.startTime}
                    </Typography>

                    {eventHasOverlap && (
                      <div style={{ width: "95%", textAlign: "center" }}>
                        <ErrorIcon
                          style={{
                            color: "#d50000",
                            height: 22,
                            width: 22,
                          }}
                        />
                      </div>
                    )}
                  </td>
                )}
              {this.props.isEvent ? (
                <td valign={"top"}>
                  <Typography variant="body2" style={{ marginBottom: 5 }}>
                    {this.props.break.name}
                  </Typography>
                  {eventTeams.length > 0 && (
                    <Typography
                      variant="body2"
                      style={{
                        height: 24,
                        border: "1px solid gray",
                        borderRadius: 25,
                        paddingLeft: 8,
                        paddingRight: 8,
                        width: "fit-content",
                      }}
                    >
                      {eventTeams.length > 3 ? (
                        <span>
                          <span>
                            <LightTooltip
                              title={
                                <div>
                                  {eventTeams.map((t, i) => {
                                    let team = this.props.teamsByKey[t] || {};
                                    let overlapCount = overlapCounts[t] || 0;
                                    return (
                                      <div key={t}>
                                        <Typography
                                          variant="body2"
                                          style={{
                                            color:
                                              overlapCount > 1 ? "#d50000" : "",
                                          }}
                                        >
                                          {team.name || ""}
                                        </Typography>
                                      </div>
                                    );
                                  })}
                                </div>
                              }
                              placement="top"
                              arrow
                            >
                              <span
                                style={{
                                  color: eventHasOverlap ? "#d50000" : "black",
                                }}
                              >
                                {eventTeams.length.toString() +
                                  " " +
                                  (this.props.tournament.individualPlayers
                                    ? languages.teams.playersLow
                                    : languages.tournament.teamsLow)}
                              </span>
                            </LightTooltip>
                          </span>
                        </span>
                      ) : (
                        eventTeams.map((t, i) => {
                          let team = this.props.teamsByKey[t] || {};
                          let overlapCount = overlapCounts[t] || 0;
                          return (
                            <span
                              key={t}
                              className={"bothTeamElementbreak bothTeamElement"}
                              onMouseOver={() => {
                                this.highlightTeam(t);
                              }}
                              onMouseLeave={() => {
                                this.unHighlightTeam(t);
                              }}
                            >
                              <span
                                id={this.props.break.id + i.toString()}
                                className={"teamElementbreak teamElementId" + t}
                                style={{
                                  color: overlapCount > 1 ? "#d50000" : "",
                                }}
                              >
                                {team.name}
                              </span>
                              {eventTeams.length - 1 > i && <span>{", "}</span>}
                            </span>
                          );
                        })
                      )}
                    </Typography>
                  )}
                </td>
              ) : (
                <td valign={"top"}>
                  <Typography variant="body2" style={{ marginBottom: 5 }}>
                    {this.props.break.name}
                  </Typography>
                  <div style={{ display: "flex" }}>
                    <Chip
                      size="small"
                      label={
                        this.props.break.duration +
                        " " +
                        languages.schedule.minutes
                      }
                      style={{
                        color: "black",
                        background: "rgba(166, 162, 162, 0.05)",
                        border: "1px solid gray",
                      }}
                    />
                  </div>
                </td>
              )}
              <td style={{ float: "right", width: 25 }}>
                {this.state.mouseOver && (
                  <EditBreakContainer
                    tournament={this.props.tournament}
                    break={this.props.break}
                    isEvent={this.props.break.isEvent || false}
                    tournamentStatus={this.props.tournamentStatus}
                    toggleFinishedDialog={this.props.toggleFinishedDialog}
                    teams={this.props.teams}
                    teamsByKey={this.props.teamsByKey}
                    eventOptions={this.props.eventOptions}
                    divisionsObject={this.props.divisionsObject}
                    poulesByKey={this.props.poulesByKey}
                  />
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default withTheme(Break);
